import React from 'react';
import { Link } from 'react-router-dom';
import LegalDocumentLayout from '../components/LegalDocumentLayout';
import { LEGAL_LINKS } from '../data/legalLinks';
import { cookiesSections } from '../data/legalContent';

const BASE = 'https://antologia.tech';

const CookiesPolicyPage = () => (
  <LegalDocumentLayout
    title="Политика использования cookies и аналитики"
    description="Какие cookies использует antologia.tech, Яндекс.Метрика, вебвизор и как управлять согласием."
    canonical={`${BASE}${LEGAL_LINKS.cookies}`}
    sections={cookiesSections}
  >
    <p className="text-sm text-muted-foreground">
      См. также{' '}
      <Link to={LEGAL_LINKS.privacy} className="text-accent hover:underline">
        политику обработки персональных данных
      </Link>
      .
    </p>
  </LegalDocumentLayout>
);

export default CookiesPolicyPage;
